<template>
	<div></div>
</template>

<script>
export default {
	name: 'Logout',
	created() {
		this.logoutHandler();
	},
	methods: {
		logoutHandler() {
			let logout_confirm = confirm(this.$t('alert.logout'));
			if (logout_confirm) {
				this.$store.dispatch('auth/logout');
				this.$router.push({ name: 'home' });
			}
		},
	},
};
</script>

<style scoped></style>
